import AuthService from "../../../../services/AuthService";

export default class EntrepriseService {
    constructor() {
        this.Auth = new AuthService();
    }

    addNewPoste(data) {
        return this.Auth.fetch('/societe/poste', {method: data.edit ? 'PUT' : 'POST', data: data});
    }

    getEntreprisePostes() {
        return this.Auth.fetch('/societe/postes');
    }

    deletePoste(poste_id) {
        return this.Auth.fetch('/societe/poste/' + poste_id, {method: 'DELETE'})
    }

    getPosteCandidatures(poste_id) {
        return this.Auth.fetch('/societe/poste/' + poste_id + '/candidatures')
    }

    acceptCandidature(candidatureId, accept) {
        return this.Auth.fetch('/societe/poste/candidature/' + candidatureId + '/accept',
            {
                method: 'POST',
                data: {accept: accept}
            });
    }

}


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/services/EntrepriseService.js